import { boolean, number, object, string } from "yup";

export const createVideoValidationSchema = object().shape({
    title: string().required("Title is required"),
    description: string().required("Description is required"),
    videoId: string().required("Video is required"),
    thumbnailId: number().positive().required("Thumbnail is required"),
    isTrailer: boolean().required("Is Trailer is required"),
    publisherId: number().required("Publisher is required"),
});
